import React from '../../vendor/react';
import { useEffect } from '../../vendor/react';
import { navigate, useLocation } from '../../vendor/react-router-dom';
import { BrandMark } from '../layout/BrandMark';
import { useAuth } from '../../features/auth/auth-store';
import type { ReactNode } from '../../vendor/react';

function LoadingScreen() {
  return <div className="auth-loading"><BrandMark /><span className="loading-spinner" /><p>Preparando tu espacio de trabajo…</p></div>;
}

export function ProtectedGate({ children }: { children?: ReactNode }) {
  const auth = useAuth();
  const location = useLocation();
  useEffect(() => {
    if (auth.status !== 'ready') return;
    if (!auth.session) navigate(`/ingresar?next=${encodeURIComponent(location.pathname)}`, { replace: true });
    else if (!auth.workspace?.onboardingComplete) navigate('/onboarding', { replace: true });
  }, [auth.status, auth.session?.user.id, auth.workspace?.onboardingComplete, location.pathname]);
  if (auth.status !== 'ready' || !auth.session || !auth.workspace?.onboardingComplete) return <LoadingScreen />;
  return <>{children}</>;
}

export function OnboardingGate({ children }: { children?: ReactNode }) {
  const auth = useAuth();
  useEffect(() => {
    if (auth.status !== 'ready') return;
    if (!auth.session) navigate('/ingresar', { replace: true });
    else if (auth.workspace?.onboardingComplete) navigate('/app', { replace: true });
  }, [auth.status, auth.session?.user.id, auth.workspace?.onboardingComplete]);
  if (auth.status !== 'ready' || !auth.session || auth.workspace?.onboardingComplete) return <LoadingScreen />;
  return <>{children}</>;
}

export function GuestGate({ children }: { children?: ReactNode }) {
  const auth = useAuth();
  useEffect(() => {
    if (auth.status === 'ready' && auth.session && (auth.session.user.platformRole === 'superadmin' || auth.session.user.platformRole === 'support')) navigate('/admin', { replace: true });
    else if (auth.status === 'ready' && auth.session && auth.workspace?.onboardingComplete) navigate('/app', { replace: true });
    else if (auth.status === 'ready' && auth.session && !auth.workspace?.onboardingComplete) navigate('/onboarding', { replace: true });
  }, [auth.status, auth.session?.user.id, auth.workspace?.onboardingComplete]);
  if (auth.status !== 'ready' || auth.session) return <LoadingScreen />;
  return <>{children}</>;
}

export function AdminGate({ children }: { children?: ReactNode }) {
  const auth = useAuth();
  const location = useLocation();
  useEffect(() => {
    if (auth.status !== 'ready') return;
    if (!auth.session) navigate(`/ingresar?next=${encodeURIComponent(location.pathname)}`, { replace: true });
    else if (auth.session.user.platformRole !== 'superadmin' && auth.session.user.platformRole !== 'support') navigate('/app', { replace: true });
  }, [auth.status, auth.session?.user.id, auth.session?.user.platformRole, location.pathname]);
  if (auth.status !== 'ready' || !auth.session || (auth.session.user.platformRole !== 'superadmin' && auth.session.user.platformRole !== 'support')) return <LoadingScreen />;
  return <>{children}</>;
}
